module.exports = __webpack_public_path__ + "static/media/RENAULT_LOGO_english.99a35d72.png";